import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'lucide-react';
const purchases = [{
  name: 'Lena K.',
  city: 'Berlin 🇩🇪',
  time: 'VOR 6 MIN'
}, {
  name: 'Sophie M.',
  city: 'Köln 🇩🇪',
  time: 'VOR 9 MIN'
}, {
  name: 'Marie L.',
  city: 'Frankfurt 🇩🇪',
  time: 'VOR 12 MIN'
}, {
  name: 'Anna S.',
  city: 'München 🇩🇪',
  time: 'VOR 15 MIN'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseIndex, setPurchaseIndex] = useState(0);
  useEffect(() => {
    const showTimer = window.setTimeout(() => setIsVisible(true), 3500);
    const rotateTimer = window.setInterval(() => {
      setPurchaseIndex(current => (current + 1) % purchases.length);
      setIsVisible(true);
    }, 9000);
    return () => {
      window.clearTimeout(showTimer);
      window.clearInterval(rotateTimer);
    };
  }, []);
  const purchase = purchases[purchaseIndex];
  return <AnimatePresence mode="wait" data-id="element-135">
      {isVisible && <motion.aside key={purchase.name} initial={{
      opacity: 0,
      x: -20,
      y: 24
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -16,
      y: 16
    }} transition={{
      duration: 0.35
    }} aria-live="polite" className="fixed bottom-4 left-4 z-50 flex max-w-[calc(100vw-2rem)] items-start gap-3 rounded-2xl border border-brand-creamDark bg-white p-4 pr-10 shadow-xl sm:bottom-6 sm:left-6 sm:max-w-sm" data-id="element-136">
          <button type="button" onClick={() => setIsVisible(false)} aria-label="Kaufmeldung schließen" className="absolute right-2.5 top-2.5 rounded p-0.5 text-brand-gray transition-colors hover:text-brand-text focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-green" data-id="element-137">
            <X className="h-4 w-4" aria-hidden="true" data-id="element-138" />
          </button>
          <div className="mt-0.5 text-2xl" aria-hidden="true" data-id="element-139">
            🧘‍♀️
          </div>
          <div data-id="element-140">
            <p className="mb-0.5 text-sm font-bold text-brand-text" data-id="element-141">
              {purchase.name} · {purchase.city}
            </p>
            <p className="mb-1 text-xs font-bold text-brand-green" data-id="element-142">
              hat YOGA BEREIT gekauft
            </p>
            <p className="flex items-center gap-1.5 text-[10px] font-medium tracking-wide text-brand-gray" data-id="element-143">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-brand-green" aria-hidden="true" data-id="element-144" />
              VERIFIZIERTER KAUF · {purchase.time}
            </p>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}